export function prepareTryoutProfile(profile) {
  if (profile.kodeSubTipeCbt !== 'TRYOUT') return { ...profile };
  if (!profile.idKelasGroup || Number(profile.idKelasGroup) <= 0) {
    throw new Error('Pilih Kelas Group untuk tryout agar jadwal dapat dilihat siswa.');
  }
  return { ...profile, idKelas: null };
}

// Isi awal form "+ Profil" satu halaman (mis. TOO/TRYOUT). Dipakai saat form dibuka, ditutup, dan sesudah simpan,
// supaya profil berikutnya tidak terkirim tanpa kode tipe.
export function emptyProfileFor(kodeTipeCbt, kodeSubTipeCbt) {
  return { kodeTipeCbt, kodeSubTipeCbt };
}
